import { faCircle } from "@jewlr/pro-solid-svg-icons/faCircle"
import { faDiamond } from "@jewlr/sharp-solid-svg-icons/faDiamond"
import { faHeart } from "@jewlr/sharp-solid-svg-icons/faHeart"
import { faSquare } from "@jewlr/sharp-solid-svg-icons/faSquare"
import PropTypes from "prop-types"
import { Fragment } from "react"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

const confettiMap = {
  0: faDiamond,
  1: faSquare,
  2: faCircle,
  3: faHeart,
}

const LandingMarquee = ({ element }) => {
  const items = (hidden = false) =>
    (element.data?.items || []).map((item, i) => {
      return (
        <Fragment key={`marquee-${i}`}>
          <li
            className={cn(
              "body mx-16 inline-flex items-center font-semibold",
              element.style?.classNames?.itemClassName,
              item.style?.className
            )}
            {...(hidden && { "aria-hidden": true })}
            {...element.style?.itemProps}
            role="none"
          >
            <FontAwesomeIcon className="text-10" icon={confettiMap[i % 4]} />
          </li>
          <li
            className={cn(
              "body mx-16 inline-flex items-center font-semibold",
              element.style?.classNames?.itemClassName,
              item.style?.className
            )}
            {...(hidden && { "aria-hidden": true })}
            {...element.style?.itemProps}
          >
            {item.text}
          </li>
        </Fragment>
      )
    })

  return (
    <div
      className={cn(
        "bg-black-print text-white",
        element.style?.classNames?.blockClassName
      )}
      {...element.style?.blockProps}
    >
      <div
        className={cn(
          "mask-fade py-32",
          element.contain && "contained-wide",
          element.style?.classNames?.containerClassName
        )}
        {...element.style?.containerProps}
      >
        <div className="user-select-none relative flex overflow-hidden">
          <ul
            className={cn(
              "animate-scroll min-w-fit shrink-0 list-none items-baseline justify-around uppercase",
              element.style?.classNames?.marqueeClassName
            )}
            {...element.style?.marqueeProps}
          >
            {items()}
            {items(true)}
          </ul>
          <ul
            aria-hidden
            className={cn(
              "animate-scroll min-w-fit shrink-0 list-none items-baseline justify-around uppercase",
              element.style?.classNames?.marqueeClassName
            )}
            {...element.style?.marqueeProps}
          >
            {items()}
            {items()}
          </ul>
        </div>
      </div>
    </div>
  )
}

LandingMarquee.propTypes = {
  element: PropTypes.object,
}

export default LandingMarquee
